document.addEventListener("DOMContentLoaded", () => {
  class YGProductMegeMenu extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.triggers = Array.from(
        this.querySelectorAll("[data-yg-product-tab]")
      );
      this.panels = Array.from(
        this.querySelectorAll("[data-yg-product-panel]")
      );

      if (!this.triggers.length || !this.panels.length) return;

      const activeTrigger =
        this.triggers.find((trigger) =>
          trigger.classList.contains("is-active")
        ) || this.triggers[0];

      this.activatePanel(activeTrigger.dataset.ygProductTab);

      this.triggers.forEach((trigger) => {
        trigger.addEventListener("mouseenter", () => {
          this.activatePanel(trigger.dataset.ygProductTab);
        });

        trigger.addEventListener("focus", () => {
          this.activatePanel(trigger.dataset.ygProductTab);
        });

        trigger.addEventListener("click", () => {
          this.activatePanel(trigger.dataset.ygProductTab);
        });
      });
    }

    activatePanel(panelId) {
      if (!panelId) return;

      this.triggers.forEach((trigger) => {
        const isActive = trigger.dataset.ygProductTab === panelId;

        trigger.classList.toggle(
          "is-active",
          isActive
        );

        if (trigger.hasAttribute("aria-selected")) {
          trigger.setAttribute("aria-selected", isActive ? "true" : "false");
        }
      });

      this.panels.forEach((panel) => {
        panel.classList.toggle(
          "is-active",
          panel.dataset.ygProductPanel === panelId
        );
      });
    }
  }

  if (!window.customElements.get("yg-product-mege-menu")) {
    window.customElements.define("yg-product-mege-menu", YGProductMegeMenu);
  }

  class YGSeriesMegaMenu extends YGProductMegeMenu {}

  if (!window.customElements.get("yg-series-mega-menu")) {
    window.customElements.define("yg-series-mega-menu", YGSeriesMegaMenu);
  }

  class YGProductNavigationPromoBlock extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.items = Array.from(
        this.querySelectorAll("[data-yg-product-nav-item]")
      );
      this.buttons = Array.from(
        this.querySelectorAll("[data-yg-product-nav-toggle]")
      );
      this.panels = Array.from(
        this.querySelectorAll("[data-yg-product-nav-panel]")
      );

      if (!this.buttons.length || !this.panels.length) return;

      const initialId = this.buttons[0].dataset.ygProductNavToggle;
      this.expandItem(initialId);

      this.buttons.forEach((button) => {
        button.addEventListener("click", () => {
          const itemId = button.dataset.ygProductNavToggle;
          const isExpanded = button.getAttribute("aria-expanded") === "true";

          if (isExpanded) {
            this.collapseAll();
            return;
          }

          this.expandItem(itemId);
        });
      });
    }

    collapseAll() {
      this.items.forEach((item) => {
        item.classList.remove("is-active");
      });

      this.buttons.forEach((button) => {
        button.classList.remove("is-active");
        button.setAttribute("aria-expanded", "false");
      });

      this.panels.forEach((panel) => {
        panel.classList.remove("is-active");
        panel.hidden = true;
      });
    }

    expandItem(itemId) {
      if (!itemId) return;

      this.collapseAll();

      const item = this.items.find(
        (element) => element.dataset.ygProductNavItem === itemId
      );
      const button = this.buttons.find(
        (element) => element.dataset.ygProductNavToggle === itemId
      );
      const panel = this.panels.find(
        (element) => element.dataset.ygProductNavPanel === itemId
      );

      if (item) {
        item.classList.add("is-active");
      }

      if (button) {
        button.classList.add("is-active");
        button.setAttribute("aria-expanded", "true");
      }

      if (panel) {
        panel.classList.add("is-active");
        panel.hidden = false;
      }
    }
  }

  if (!window.customElements.get("yg-product-navigation-promo-block")) {
    window.customElements.define(
      "yg-product-navigation-promo-block",
      YGProductNavigationPromoBlock
    );
  }

  class YGSeriesNavigationPromoBlock extends YGProductNavigationPromoBlock {}

  if (!window.customElements.get("yg-series-navigation-promo-block")) {
    window.customElements.define(
      "yg-series-navigation-promo-block",
      YGSeriesNavigationPromoBlock
    );
  }

  class YGProductCardImages extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      const swiper = new Swiper(this, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 40,
        navigation: {
          nextEl: this.querySelector(".yg-swiper-button-next"),
          prevEl: this.querySelector(".yg-swiper-button-prev"),
          disabledClass: 'swiper-button-lock'
        },
        pagination: {
          el: this.querySelector(".yg-swiper-pagination"),
          clickable: true,
          type: "progressbar"
        },

      });

    }
  }

  if (!window.customElements.get("yg-product-card-images")) {
    window.customElements.define("yg-product-card-images", YGProductCardImages);
  }

  class YGPumperTierPriceSync {
    constructor() {
      this.moneyPattern =
        /(?:US\$|CA\$|AU\$|\$)\s*\d[\d,]*(?:\.\d+)?|\d[\d,]*(?:\.\d+)?\s*(?:USD|EUR|GBP|CAD|AUD)/gi;
      this.moneyTestPattern =
        /(?:US\$|CA\$|AU\$|\$)\s*\d[\d,]*(?:\.\d+)?|\d[\d,]*(?:\.\d+)?\s*(?:USD|EUR|GBP|CAD|AUD)/i;
      this.unitPricePattern =
        /((?:US\$|CA\$|AU\$|\$)\s*\d[\d,]*(?:\.\d+)?|\d[\d,]*(?:\.\d+)?\s*(?:USD|EUR|GBP|CAD|AUD))\s*\/\s*([a-z]+)/i;
      this.debouncedSync = this.debounce(() => this.syncSelectedTier(), 80);
      this.observer = null;
    }

    init() {
      if (window.themeVariables?.settings?.pageType !== "product") return;

      document.addEventListener("click", this.handleTierInteraction.bind(this), true);
      document.addEventListener("change", this.handleTierInteraction.bind(this), true);
      document.addEventListener("variant:change", (event) => {
        const formId = event.detail?.formId || "";

        if (formId && !formId.startsWith("product-form-")) return;

        this.clearThemePriceSnapshots();
        window.setTimeout(() => this.syncSelectedTier(), 250);
      });

      this.observer = new MutationObserver((mutations) => {
        if (!this.hasRelevantMutation(mutations)) return;

        this.debouncedSync();
      });
      this.observer.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ["class", "aria-checked", "aria-selected", "checked"]
      });

      window.setTimeout(() => this.syncSelectedTier(), 800);
      window.setTimeout(() => this.syncSelectedTier(), 2000);
    }

    debounce(callback, delay) {
      let timeoutId;

      return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => callback(...args), delay);
      };
    }

    hasRelevantMutation(mutations) {
      return mutations.some((mutation) => {
        const target = mutation.target instanceof Element ? mutation.target : null;

        if (target && this.isPumperRelatedElement(target)) {
          return true;
        }

        return Array.from(mutation.addedNodes || []).some((node) => {
          return node instanceof Element && this.isPumperRelatedElement(node);
        });
      });
    }

    isPumperRelatedElement(element) {
      const className = typeof element.className === "string" ? element.className : element.getAttribute("class") || "";
      const marker = `${element.id || ""} ${className} ${Object.keys(element.dataset || {}).join(" ")}`;
      const text = this.normalizeText(element.textContent || "");

      return /pumper/i.test(marker) || (/volume pricing/i.test(text) && /\bunits?\b/i.test(text));
    }

    handleTierInteraction(event) {
      const tierElement = this.findTierElement(event.target);

      if (!tierElement) return;

      window.setTimeout(() => {
        const selectedTierElement = this.findSelectedTierElement(tierElement) || tierElement;
        const tierPrice = this.parseTierPrice(selectedTierElement);

        if (tierPrice) {
          this.applyTierPrice(tierPrice);
        }
      }, 80);
    }

    syncSelectedTier() {
      const selectedTierElement = this.findSelectedTierElement(document.body);

      if (!selectedTierElement) return;

      const tierPrice = this.parseTierPrice(selectedTierElement);

      if (tierPrice) {
        this.applyTierPrice(tierPrice);
      }
    }

    findTierElement(target) {
      let element = target instanceof Element ? target : target?.parentElement;
      let depth = 0;

      while (element && element !== document.body && depth < 8) {
        if (this.parseTierPrice(element)) {
          return element;
        }

        element = element.parentElement;
        depth += 1;
      }

      return null;
    }

    findSelectedTierElement(scope) {
      const root = this.findPumperRoot(scope) || document;
      const checkedInput = root.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      const checkedTier = checkedInput ? this.findTierElement(checkedInput) : null;

      if (checkedTier) return checkedTier;

      const selectedElements = Array.from(
        root.querySelectorAll('[aria-checked="true"], [aria-selected="true"], [data-selected="true"]')
      );
      const selectedTier = selectedElements.map((element) => this.findTierElement(element)).find(Boolean);

      if (selectedTier) return selectedTier;

      return Array.from(root.querySelectorAll("*"))
        .filter((element) => {
          const className = typeof element.className === "string" ? element.className : element.getAttribute("class") || "";

          return /(?:selected|active|checked)/i.test(className);
        })
        .map((element) => this.findTierElement(element))
        .find(Boolean);
    }

    findPumperRoot(scope) {
      let element = scope instanceof Element ? scope : scope?.parentElement;

      while (element && element !== document.body) {
        if (this.isPumperRelatedElement(element)) {
          return element;
        }

        element = element.parentElement;
      }

      return document.querySelector('[id*="pumper"], [class*="pumper"], [data-pumper]');
    }

    parseTierPrice(element) {
      if (!(element instanceof Element)) return null;

      const text = this.normalizeText(element.textContent || "");

      if (!this.isTierText(text)) return null;

      const unitMatch = text.match(this.unitPricePattern);
      const moneyMatches = text.match(this.moneyPattern) || [];

      if (!moneyMatches.length) return null;

      const primaryText = this.normalizeMoneyText(unitMatch ? unitMatch[1] : moneyMatches[moneyMatches.length - 1]);
      const unitSuffix = unitMatch ? `/${unitMatch[2].toLowerCase()}` : "";
      const primaryValue = this.parseMoneyValue(primaryText);
      const compareText = moneyMatches
        .map((moneyText) => this.normalizeMoneyText(moneyText))
        .find((moneyText) => {
          const moneyValue = this.parseMoneyValue(moneyText);

          return moneyText !== primaryText && moneyValue > primaryValue;
        });

      return {
        priceText: primaryText,
        priceValue: primaryValue,
        compareText,
        compareValue: compareText ? this.parseMoneyValue(compareText) : null,
        unitSuffix,
        isDiscounted: Boolean(compareText) || /(?:off|save|\/\s*(?:unit|each|ea|pc|pcs))/i.test(text)
      };
    }

    isTierText(text) {
      return (
        this.moneyTestPattern.test(text) &&
        /(?:\bunits?\b|\/\s*(?:unit|each|ea|pc|pcs)|standard price)/i.test(text)
      );
    }

    normalizeText(text) {
      return text.replace(/\s+/g, " ").trim();
    }

    normalizeMoneyText(text) {
      return this.normalizeText(text).replace(/\s+/g, "");
    }

    parseMoneyValue(text) {
      const numericValue = this.normalizeMoneyText(text).replace(/[^\d.]/g, "");

      return Number.parseFloat(numericValue) || 0;
    }

    getTierDisplayPrice(tierPrice) {
      return tierPrice.priceText;
    }

    applyTierPrice(tierPrice) {
      this.updateBuyButtonsPrice(tierPrice);
      this.updateAnchorPrice(tierPrice);
    }

    clearThemePriceSnapshots() {
      document.querySelectorAll("[data-yg-pumper-base-html]").forEach((element) => {
        delete element.dataset.ygPumperBaseHtml;
      });
    }

    updateBuyButtonsPrice(tierPrice) {
      document
        .querySelectorAll(".product-info__buy-buttons .yg-buy-buttons-info-price price-list")
        .forEach((priceList) => {
          if (!priceList.dataset.ygPumperBaseHtml) {
            priceList.dataset.ygPumperBaseHtml = priceList.innerHTML;
          }

          const salePrice = priceList.querySelector("sale-price");
          let comparePrice = priceList.querySelector("compare-at-price");
          let savePrice = priceList.querySelector(".yg-sale-price");
          if (!salePrice) return;

          this.setPriceElementText(salePrice, this.getTierDisplayPrice(tierPrice));
          salePrice.classList.toggle("text-on-sale", tierPrice.isDiscounted);

          const shouldShowComparePrice = Boolean(tierPrice.compareText && tierPrice.compareValue > tierPrice.priceValue);

          if (shouldShowComparePrice) {
            if (!comparePrice) {
              comparePrice = document.createElement("compare-at-price");
              comparePrice.className = "h4 text-subdued line-through";
              salePrice.insertAdjacentElement("afterend", comparePrice);
            }

            this.setPriceElementText(comparePrice, tierPrice.compareText);

            if (!savePrice) {
              savePrice = document.createElement("span");
              savePrice.className = "yg-sale-price text-xs";
              comparePrice.insertAdjacentElement("afterend", savePrice);
            }

            savePrice.textContent = `Save ${this.formatMoneyFromValue(tierPrice.compareValue - tierPrice.priceValue)}`;
          } else {
            comparePrice?.remove();
            savePrice?.remove();
          }
        });
    }

    updateAnchorPrice(tierPrice) {
      document.querySelectorAll(".yg-anchor-tab .yg-current-variant-container").forEach((container) => {
        const priceElement = container.querySelector(".yg-price");
        const comparePriceElement = container.querySelector(".yg-compare-price");
        let salePriceElement = container.querySelector(".yg-sale-price");

        if (!priceElement) return;

        if (!container.dataset.ygPumperBaseHtml) {
          container.dataset.ygPumperBaseHtml = container.innerHTML;
        }

        priceElement.textContent = this.getTierDisplayPrice(tierPrice);

        if (comparePriceElement) {
          const shouldShowComparePrice = Boolean(tierPrice.compareText && tierPrice.compareValue > tierPrice.priceValue);
          comparePriceElement.textContent = shouldShowComparePrice ? tierPrice.compareText : "";
          comparePriceElement.hidden = !shouldShowComparePrice;

          if (shouldShowComparePrice) {
            if (!salePriceElement) {
              salePriceElement = document.createElement("span");
              salePriceElement.className = "yg-sale-price text-xs";
              comparePriceElement.insertAdjacentElement("afterend", salePriceElement);
            }
            salePriceElement.textContent = `Save ${this.formatMoneyFromValue(tierPrice.compareValue - tierPrice.priceValue)}`;
          } else {
            salePriceElement?.remove();
          }
        }
      });
    }

    setPriceElementText(priceElement, priceText) {
      const screenReaderLabel = priceElement.querySelector(".sr-only")?.cloneNode(true);

      priceElement.textContent = "";

      if (screenReaderLabel) {
        priceElement.appendChild(screenReaderLabel);
      }

      priceElement.appendChild(document.createTextNode(priceText));
    }

    formatMoneyFromValue(value) {
      const cents = Math.round(value * 100);
      const format = window.themeVariables?.settings?.moneyFormat || "$";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const match = format.match(placeholderRegex);
      const amount = cents / 100;

      if (!match) return `$${amount.toFixed(2)}`;

      const formatWithDelimiters = (numberValue, precision = 2, thousands = ",", decimal = ".") => {
        const parts = numberValue.toFixed(precision).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.join(decimal);
      };

      let formattedAmount;
      switch (match[1]) {
        case "amount":
          formattedAmount = formatWithDelimiters(amount);
          break;
        case "amount_no_decimals":
          formattedAmount = formatWithDelimiters(amount, 0);
          break;
        case "amount_with_comma_separator":
          formattedAmount = formatWithDelimiters(amount, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          formattedAmount = formatWithDelimiters(amount, 0, ".", ",");
          break;
        case "amount_with_apostrophe_separator":
          formattedAmount = formatWithDelimiters(amount, 2, "'", ".");
          break;
        default:
          formattedAmount = formatWithDelimiters(amount);
          break;
      }

      return format.replace(placeholderRegex, formattedAmount);
    }
  }

  new YGPumperTierPriceSync().init();
});